import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-11eaffdb")

_pushScopeId("data-v-11eaffdb")
const _hoisted_1 = { class: "apartCourse" }
const _hoisted_2 = { class: "carName" }
const _hoisted_3 = {
  key: 0,
  class: "tips"
}
const _hoisted_4 = { class: "videoList" }
const _hoisted_5 = { class: "btmFix" }
const _hoisted_6 = { class: "evaluate" }
const _hoisted_7 = /*#__PURE__*/_createVNode("i", { class: "iconfont icon-dianzan" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("i", { class: "iconfont icon-dianzan fandui" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("i", { class: "iconfont icon-liuyan1" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("span", null, "留言", -1)
const _hoisted_11 = { class: "btmFix msgBox" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_videoCom = _resolveComponent("videoCom")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("h4", _hoisted_2, _toDisplayString(_ctx.state.carName), 1),
    (_ctx.state.tip)
      ? (_openBlock(), _createBlock("div", _hoisted_3, _toDisplayString(_ctx.state.tip), 1))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_4, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.videoList, (item) => {
        return (_openBlock(), _createBlock(_component_videoCom, {
          key: item.videoId,
          videoData: item,
          class: "DetectPlayer"
        }, null, 8, ["videoData"]))
      }), 128))
    ]),
    _withDirectives(_createVNode("div", _hoisted_5, [
      _createVNode("div", _hoisted_6, [
        _withDirectives(_createVNode("div", {
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clickGood && _ctx.clickGood(...args))),
          class: {'active': _ctx.state.goodType}
        }, [
          _hoisted_7,
          _createVNode("span", null, _toDisplayString(_ctx.state.goodNum), 1)
        ], 2), [
          [_vShow, !_ctx.state.badType]
        ]),
        _withDirectives(_createVNode("div", {
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.clickBad && _ctx.clickBad(...args))),
          class: {'active': _ctx.state.badType}
        }, [
          _hoisted_8,
          _createVNode("span", null, _toDisplayString(_ctx.state.badNum), 1)
        ], 2), [
          [_vShow, !_ctx.state.goodType]
        ])
      ]),
      _createVNode("div", {
        class: "liuyan",
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.leaveMsg && _ctx.leaveMsg(...args)))
      }, [
        _hoisted_9,
        _hoisted_10
      ])
    ], 512), [
      [_vShow, !_ctx.state.lvmsg]
    ]),
    _withDirectives(_createVNode("div", _hoisted_11, [
      _withDirectives(_createVNode("textarea", {
        class: "messageCont",
        "max-length": "200",
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.state.message = $event)),
        placeholder: "请输入"
      }, null, 512), [
        [_vModelText, _ctx.state.message]
      ]),
      _createVNode("button", {
        class: {'active': _ctx.state.message.length > 0},
        disabled: _ctx.state.message.length === 0,
        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.updateMsg && _ctx.updateMsg(...args)))
      }, " 发表 ", 10, ["disabled"])
    ], 512), [
      [_vShow, _ctx.state.lvmsg]
    ])
  ]))
})